import { colorsSets } from "@similarweb/styles";

export const PERIOD_OVER_PERIOD_COLOR_SCALE = {
    red: [
        colorsSets.heatmapSequential["red 200"],
        colorsSets.heatmapSequential["red 300"],
        colorsSets.heatmapSequential["red 400_P"],
        colorsSets.heatmapSequential["red 500"],
        colorsSets.heatmapSequential["red 600"],
    ],
    green: [
        colorsSets.heatmapSequential["green 200"],
        colorsSets.heatmapSequential["green 300"],
        colorsSets.heatmapSequential["green 400_P"],
        colorsSets.heatmapSequential["green 500"],
        colorsSets.heatmapSequential["green 600"],
    ],
} as const;
